import { api } from '@/lib/api'

import type {
	ActionData,
	ActionDetails,
	ActionListRequest,
	RunAsynchronousActionDTO,
} from './types'

/**
 * Fetch all action
 * @param tenant - Tenant ID
 * @param [signal] - Abort Signal (optional)
 */
export const fetchActionList = async (tenant: string, signal?: AbortSignal) => {
	const {
		data: { actions },
	} = await api.get<ActionListRequest>(
		`/api/tenants/${tenant}/soar/available_actions`,
		{
			signal,
		},
	)

	if (actions.length === 0) return []

	return actions
}

/**
 * Fetch details of an action
 * @param tenant - Tenant ID
 * @param action_id - Action ID
 * @param [signal] - Abort Signal (optional)
 */
export const fetchActionDetails = async (
	tenant: string,
	action_id: string,
	signal?: AbortSignal,
): Promise<ActionDetails> => {
	const { data } = await api.get<ActionDetails>(
		`/api/tenants/${tenant}/soar/available_actions/${action_id}`,
		{
			signal,
		},
	)

	return data
}

/**
 * Run an asynchronous action
 * @param tenant - Tenant ID
 * @param module_data - Action data
 */
export const runAsynchronousAction = async (
	tenant: string,
	module_data: ActionData,
) => {
	const { data } = await api.post<RunAsynchronousActionDTO>(
		`/api/tenants/${tenant}/soar/actions_activity`,
		module_data,
	)

	return data
}
